#import "../fragments/stageset-widgets-fragment.graphql"

query GetStagesetWidgets($id: ID!) {
    stageset(id: $id) {
        ...StagesetWidgetsFragment
    }
}
